import { PersonPhoneDto, PersonEmailDto, PersonAddressDto, PersonDto, ClientResources } from '@app/api2/api';
import * as Yup from 'yup';

export type ContactTypeMembers = Pick<PersonDto, 'id' | 'phones' | 'emails' | 'addresses'>;

export const AddressSchema: (t: ClientResources) => Yup.SchemaOf<PersonAddressDto> = (t: ClientResources) => Yup.object().shape({
    id: Yup.number().optional().nullable().meta({ search: false }),
    addressTypeId: Yup.number().label(t.metadata.addressTypeLabel || 'Address Type').required(),
    addressLine1: Yup.string().max(100).label(t.metadata.addressLine1Label || 'Address Line 1').required(),
    addressLine2: Yup.string().max(100).label(t.metadata.addressLine2Label || 'Address Line 2').optional(),
    addressCityId: Yup.number().optional().nullable().label(t.metadata.cityLabel || 'City').test('city-test', 'City is required', (value, record) => {
        return !!value || !!record.parent.addressCityName;
    }),
    addressCityName: Yup.string().max(100).label(t.metadata.cityLabel || 'City').test('city-test2', 'City is required', (value, record) => {
        return !!value || !!record.parent.addressCityId;
    }).meta({ search: false }),
    addressId: Yup.number().optional().meta({ search: false }),
    personId: Yup.number().optional().meta({ search: false }),
    addressStateName: Yup.string().max(100).optional().nullable().label(t.metadata.stateLabel || 'State').test('state-test', 'State is required', (value, record) => {
        return !!value || !!record.parent.addressStateId;
    }).meta({ search: false }), //.required('State is required'),
    addressStateId: Yup.number().optional().nullable().label(t.metadata.stateLabel || 'State').test('state-test2', 'State is required', (value, record) => {
        return !!value || !!record.parent.addressStateName;
    }),
    addressCountryId: Yup.number().label(t.metadata.countryLabel || 'Country').required(),
    addressPostalCode: Yup.string().max(20).label(t.metadata.postalCodeLabel || 'Postal Code').required(),
    addressIsPrimary: Yup.boolean().label(t.metadata.isPrimaryLabel || 'Is Primary').required().meta({ search: false }),
    addressEndDate: Yup.date().label(t.metadata.endDateLabel || 'End Date').optional().nullable() as any,
    addressStartDate: Yup.date().label(t.metadata.startDateLabel || 'Start Date').optional().nullable() as any,
}) as Yup.SchemaOf<PersonAddressDto>

export const PhoneSchema = (t: ClientResources) => Yup.object().shape({
    phoneTypeId: Yup.number().label(t.metadata.phoneTypeLabel || 'Phone Type').required(),
    phoneNumber: Yup.string().label(t.metadata.phoneNumberLabel || 'Phone Number').max(16).required(),
    id: Yup.number().optional().nullable().meta({ search: false }),
}) as Yup.SchemaOf<PersonPhoneDto>

export const EmailSchema = (t: ClientResources) => Yup.object().shape({
    id: Yup.number().optional().nullable().meta({ search: false }),
    emailAddress: Yup.string().label(t.metadata.emailAddressLabel || 'Email Address').email(t.metadata.invalidEmail || 'Invalid email').max(320).required(),
}) as Yup.SchemaOf<PersonEmailDto>

export const ContactSchema: (t: ClientResources) => Yup.SchemaOf<ContactTypeMembers> = (t) => Yup.object({
    id: Yup.number().optional().nullable().meta({ search: false }),
    phones: Yup.array().of(
        PhoneSchema(t)
    ).label(t.metadata.phonesLabel || 'Phones'),
    emails: Yup.array().of(
        EmailSchema(t)
    ).label(t.metadata.emailsLabel || 'Emails'),
    addresses: Yup.array().of(
        AddressSchema(t)
    ).label(t.metadata.addressesLabel || 'Addresses'),
});


type ContactTypeMembersObject = Record<(keyof ContactTypeMembers), undefined>;

const contactDefProperties: ContactTypeMembersObject = {
    id: undefined,
    phones: undefined,
    emails: undefined,
    addresses: undefined,
};

export const ALL_CONTACT_PROPERTIES = Object.keys(contactDefProperties) as (keyof ContactTypeMembers)[];
